import React from 'react';
import { isEmail } from 'validator';

import { Col, FormGroup, Label, Row, InputGroup, InputGroupText, FormSection, Switch } from 'twyne-new.ui'
import { Input, InputMergeTag } from './utils'
import { globalMergeTags } from './options'

import Select from 'components/form/Select';
import HTMLEditorPreview from 'components/form/HTMLEditorPreview';
import Propagable from 'components/Propagable';
import _ from 'lodash';
import FileUpload from '@/components/FileUpload';

export default class Delivery extends Propagable {

  state = {
    email: {},
    ftp: {},
    sftp: {},
  }

  render() {
    const { vendor, disabled } = this.props
    const { [vendor]: data } = this.state

    if (vendor === 'email')
      return <DeliveryEmail data={data} onChange={this.handleChange(vendor)} />

    if (vendor === 'ftp')
      return <DeliveryFTP data={data} onChange={this.handleChange(vendor)} />

    if (vendor === 'sca')
      return <DeliveryFTP data={data} onChange={this.handleChange(vendor)} disabled={disabled} validateCredentialsSCA={this.props.validateCredentialsSCA} />

    if (vendor === 'sftp')
      return <DeliverySFTP data={data} onChange={this.handleChange(vendor)} />

    return null
  }
}

class DeliveryEmail extends Propagable {
  state = {
    from_name: '',
    email_to: '',
    email_cc: '',
    email_bcc: '',
    subject: '',
    body: '',
  }

  name = named('email')

  EmailField = (props) => {
    return <Select creatable multi
      {...props}
      clearable={false}
      promptTextCreator={str => `add "${str}"`}
      valueKey={'address'}
      labelKey={'address'}
      isValidNewOption={label => label && isEmail(label)}
      noOptionsMessage={() => 'Enter a valid email'}
      placeholder="Enter email"
      newOptionCreator={({ valueKey, label }) => ({ [valueKey]: label })}
    />
  }

  render() {
    const { from_name, email_to, email_cc, email_bcc, subject, body } = this.state

    return <Row>
      <Col size='6'>
        <FormGroup>
          <Label>From Name</Label>
          <Input required
            name={this.name('from_name')}
            value={from_name}
            onChange={this.handleChange('from_name')}
          />
        </FormGroup>
      </Col>
      <Col size='6'>
        <FormGroup>
          <Label>E-mail To</Label>
          <this.EmailField
            name={this.name('email_to')}
            value={email_to}
            handleOnChange={this.handleChange('email_to')}
            validations={{
              isValids: (_, items) => items && items.length > 0 || false
            }}
          />
        </FormGroup>
      </Col>
      <Col size='6'>
        <FormGroup>
          <Label>E-mail CC</Label>
          <this.EmailField
            name={this.name('email_cc')}
            value={email_cc}
            handleOnChange={this.handleChange('email_cc')}
          />
        </FormGroup>
      </Col>
      <Col size='6'>
        <FormGroup>
          <Label>E-mail BCC</Label>
          <this.EmailField
            name={this.name('email_bcc')}
            value={email_bcc}
            handleOnChange={this.handleChange('email_bcc')}
          />
        </FormGroup>
      </Col>
      <Col size='12'>
        <FormGroup>
          <Label>Subject</Label>
          <InputMergeTag required
            mergetags={globalMergeTags}
            name={this.name('subject')}
            value={subject}
            onChange={this.handleChange('subject')}
          />
        </FormGroup>
      </Col>
      <Col size='12'>
        <FormSection>Body</FormSection>
        <HTMLEditorPreview
          value={body}
          name={this.name('body')}
          onChange={this.handleChange('body')}
        />
      </Col>
    </Row>
  }
}

class DeliveryFTP extends Propagable {

  state = {
    host: '',
    port: '',
    user: '',
    password: '',
    directory: '',
    tls: true,
    anonymous: ''
  }

  type = 'ftp'
  name = named(this.type)
  ports = [20, 21]

  get credentialsValidations() {
    const { validateCredentialsSCA } = this.props

    if (!validateCredentialsSCA)
      return {}

    return {
      validations: {
        alreadyExists: (model) => {
          const user = _.get(model, this.name('user'))
          const password = _.get(model, this.name('password'))
          return validateCredentialsSCA(user, password)
        }
      },
      validationErrors: {
        alreadyExists: 'These credentials are already id use.'
      }
    }
  }

  get portsOptions() {
    return this.ports.map(value => ({ label: `${value}`, value })).concat({ label: 'Custom', value: '' })
  }

  Host = (props) => {
    const { type, state: { tls } } = this

    return <InputGroup>
      <InputGroupText addonType="prepend">
        {type}{tls ? 's' : ''}://
      </InputGroupText>
      <Input {...props}
        validations={{
          isHost: (_, value) => !/\w*\:*.+\/.*/.test(value),
        }}
        validationErrors={{
          isHost: 'Invalid host.',
        }} />
    </InputGroup>
  }

  Port = ({ onChange, ...props }) => {
    if (!isNaN(props.value) && this.ports.includes(parseInt(props.value)))
      return <Select
        {...props}
        options={this.portsOptions}
        clearable={false}
        setValue={onChange}
      />

    return <Input required
      {...props}
      type='number'
      onChange={onChange}
    />
  }

  Anonymous = ({ disabled }) => {
    const { anonymous } = this.state

    return <Col size='2'>
      <FormGroup>
        <Label>Anonymous</Label>
        <Switch disabled={disabled} value={anonymous || false} onChange={this.handleChange('anonymous')} />
      </FormGroup>
    </Col>
  }

  TLS = () => {
    const { tls } = this.state

    return <Col size='3'>
      <FormGroup>
        <Label>Over TLS (<small>explicit</small>)</Label>
        <Switch value={tls || false} onChange={this.handleChange('tls')} />
      </FormGroup>
    </Col>
  }

  ExtraFields = ({ disabled }) => {
    return <React.Fragment>
      <this.Anonymous disabled={disabled} />
      <this.TLS />
    </React.Fragment>
  }

  render() {
    const { credentialsValidations, props: { disabled }, state: { host, port, user, password, directory } } = this

    return <Row>
      <Col size='6'>
        <FormGroup>
          <Label>Host</Label>
          <this.Host required disabled={disabled}
            name={this.name('host')}
            value={host}
            onChange={this.handleChange('host')}
          />
        </FormGroup>
      </Col>
      <Col size='6'>
        <FormGroup>
          <Label>Port Number</Label>
          <this.Port required disabled={disabled}
            name={this.name('port')}
            value={port}
            onChange={this.handleChange('port')}
          />
        </FormGroup>
      </Col>
      <Col size='6'>
        <FormGroup>
          <Label>User Name</Label>
          <Input required={!this.disableCredentials}
            {...credentialsValidations}
            autocomplete={'off'}
            name={this.name('user')}
            value={user}
            onChange={this.handleChange('user')}
            disabled={this.disableCredentials}
          />
        </FormGroup>
      </Col>
      <Col size='6'>
        <FormGroup>
          <Label>Password</Label>
          <Input required={!this.disableCredentials}
            {...credentialsValidations}
            autocomplete={'off'}
            type='password'
            name={this.name('password')}
            value={password}
            onChange={this.handleChange('password')}
            disabled={this.disableCredentials}
          />
        </FormGroup>
      </Col>
      <Col size='6'>
        <FormGroup>
          <Label>Directory</Label>
          <Input disabled={disabled}
            name={this.name('directory')}
            value={directory}
            onChange={this.handleChange('directory')}
          />
        </FormGroup>
      </Col>
      <this.ExtraFields disabled={disabled} />
    </Row>
  }
}

class DeliverySFTP extends DeliveryFTP {

  state = {
    host: '',
    port: '',
    user: '',
    password: '',
    directory: '',
    private_key_file: ''
  }

  type = 'sftp'
  name = named(this.type)
  ports = [22]

  get disableCredentials() {
    return !!this.state.private_key_file
  }

  handleUploadPrivateKeyFile = file => {
    const reader = new FileReader();
    reader.onload = () => {
      this.handleChange('private_key_file').call(this, { content: reader.result, name: file.name })
    }
    reader.readAsDataURL(file)
  }

  PrivateKeyFile = () => {
    const { private_key_file } = this.state

    return <Col size='12'>
      <FormGroup>
        <Label>Private Key File</Label>
        <FileUpload
          value={private_key_file}
          onUpload={this.handleUploadPrivateKeyFile}
          onRemove={this.handleChange('private_key_file').bind(this, null)}
          isLoading={false}
          type='file'
        />
      </FormGroup>
    </Col>
  }

  ExtraFields = () => {
    return <React.Fragment>
      <this.PrivateKeyFile />
    </React.Fragment>
  }
}

const named = type => name => `configuration.delivery.${type}.${name}`